// extracted by mini-css-extract-plugin
export var backdropBlur = "_cn-0";
export var contentCard = "_cn-5";
export var frame = "_cn-2";
export var image = "_cn-4";
export var imagePane = "_cn-3";
export var modal = "_cn-1";